<template>
  <div class="contentbox"
       v-loading="!duplicate_submission"
       element-loading-text="提交中"
       element-loading-background="rgba(0, 0, 0, 0.8)"
       element-loading-spinner="el-icon-loading">
    <div class="toptitle">
      <span class="return">
        <span @click="on_return">&lt;</span>
      </span>
      <!--<span class="title" v-if="list_class === 0">員工</span>-->
      <!--<span class="title" v-if="list_class === 1">原列表</span>-->
      <!--<span class="title" v-if="list_class === 2">技工所</span>-->
      <span>Case</span>
      <div>
         <span class="personalicon" @click="reopenNewOrder">
          <img src="../assets/images/add.png" alt="">
        </span>
        <span @click="inorderlist">
          <img src="../assets/images/chat.png" alt="">
        </span>
        <div class="personalicon" @click="showPersonalCenter">
          <img src="../assets/images/personal.png" alt="">
        </div>
      </div>
    </div>
    <!--个人中心-->
    <mt-popup
      v-model="popupVisible"
      :modal="false"
      position="right">
      <slot>
        <div class="PersonalCenter">
          <h1>个人中心</h1>
          <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
          <div>用户名称({{$store.state.loginuserdata.username}})</div>
          <div>
            <mt-button @click="curtainlogout" type="danger">退出</mt-button>
          </div>
          <div>
            <mt-button @click="showPersonalCenter" type="primary">返回</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <!--支付方式-->
    <mt-popup
      v-model="popupVisible2"
      :modal="false"
      position="content">
      <slot>
        <div class="paymentmethod">
          <div class="price">
            <div>總金額：$ {{PostDiscountPrice}}</div>
            <div>訂金：$ {{Deposit}}</div>
            <div>已付訂金：$ {{$store.state.deposit_amount}}</div>
            <div>尚欠訂金：$ {{Deposit - $store.state.deposit_amount}}</div>
            <div>餘款：$ {{PostDiscountPrice - $store.state.deposit_amount}}</div>
          </div>
          <h1>请选择支付方式</h1>
          <Radio
            align="right"
            v-model="value"
            :options="options">
          </Radio>
          <div class="paymentmethodbut">
            <mt-button @click="onsettlement(false)" type="primary">确定</mt-button>
            <mt-button @click="onreturn(true)" type="primary">返回</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <!--审批折扣-->
    <mt-popup
      v-model="popupVisible3"
      pop-transition="popup-fade"
      closeOnClickModal="true"
      class="max_audit_box"
      :modal="true">
      <slot>
        <div class="approval_discount">
          <div>審批折扣（單位%）</div>
          <div class="input1">
            <el-input v-model="audit_preferences" size="mini"></el-input>
          </div>
          <div>備註</div>
          <div class="input">
            <textarea v-model="audit_remarks"></textarea>
          </div>
          <div class="audit_meassage">
            <div>折扣金額 $ {{audit_money}}</div>
            <div>折扣後金額 $ {{audit_total}}</div>
          </div>
          <div class="operation">
            <mt-button
              size="small"
              @click="input_audit_preferences"
              class="inorderdetails2"
              type="danger">取消
            </mt-button>
            <mt-button
              size="small"
              @click="submit_audit"
              class="inorderdetails2"
              type="primary">提交審批
            </mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <!--電子簽名-->
    <mt-popup
      v-model="popupVisible4"
      :modal="true"
      position="content">
      <slot>
        <div class="signature_box">
          <ul>
            <li>
              <el-radio v-model="signature_method" label="1">進入電子簽名頁面</el-radio>
            </li>
            <li>
              <el-radio v-model="signature_method" label="2">複製電子簽名链接</el-radio>
            </li>
          </ul>
          <div class="paymentmethodbut">
            <mt-button @click="popupVisible4 = false" type="primary">返回</mt-button>
            <mt-button @click="select_signature" type="primary">确定</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <!--新增子公司-->
    <mt-popup
      v-model="show_add_subsidiaries"
      :modal="true"
      class="add_subsidiaries_box"
      position="content">
      <slot>
        <div class="signature_box">
          <div>
            <div>
              <el-input v-model="add_subsidiaries_data.scompany_name" placeholder="分店地址"></el-input>
            </div>
            <div>
              <el-input v-model="add_subsidiaries_data.scompany_address" placeholder="送貨地址"></el-input>
            </div>
            <div>
              <el-input v-model="add_subsidiaries_data.scompany_customer" placeholder="聯絡人"></el-input>
            </div>
            <div>
              <el-input v-model="add_subsidiaries_data.scompany_phone" placeholder="電話"></el-input>
            </div>
          </div>
          <div class="paymentmethodbut">
            <mt-button @click="show_add_subsidiaries = false" type="primary">返回</mt-button>
            <mt-button @click="add_subsidiaries" type="primary">确定</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <div class="messagebox">購物提示</div>
    <div class="shoppingcartbox">
      <div class="l">
        <div class="select_product_box" v-if="false">
          <div>
            <span  class="title_name">产品类别</span>
            <el-select v-model="pro_classify_id" @change="change_classify" placeholder="请选择">
              <el-option
                v-for="item in classify"
                :key="item.pro_classify_id"
                :label="item.pro_classify_name"
                :value="item.pro_classify_id">
              </el-option>
            </el-select>
          </div>
          <div>
            <span class="title_name">安装位置</span>
            <!--list-->
            <el-select v-model="select_list" @change="change_list" placeholder="请选择">
              <el-option
                v-for="(item,index) in list"
                :key="index"
                :label="item.i_name"
                :value="item.i_id">
              </el-option>
            </el-select>

            <el-select v-model="select_list2"
                       v-if="list2.length"
                       @change="change_list2"
                       placeholder="请选择">
              <el-option
                v-for="(item,index) in list2"
                :key="index"
                :label="item.i_name"
                :value="item.i_id">
              </el-option>
            </el-select>

            <el-select v-model="select_list3"
                       v-if="list3.length"
                       @change="change_list3"
                       placeholder="请选择">
              <el-option
                v-for="(item,index) in list3"
                :key="index"
                :label="item.i_name"
                :value="item.i_id">
              </el-option>
            </el-select>
          </div>
          <div>
            <span class="title_name">产品名称/产品型号/产品SKU</span>
            <el-select v-model="product_id"
                       multiple
                       filterable
                       :filter-method="filter_method"
                       @change="select_product"
                       placeholder="关键字">
              <el-option
                v-for="(item,index) in options_product_list"
                :key="index"
                :label="item.product_name"
                :value="item.expend_id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="list_obx"
             v-show="pdfdata.length"
             v-if="false">
          <div>
            <div>产品名称</div>
            <div>产品型号</div>
            <div>产品SKU</div>
            <div>数量</div>
            <div></div>
          </div>
          <div v-for="(itme,index) in pdfdata" :key="index">
            <div>{{itme.product_name}}</div>
            <div>{{itme.product_model}}</div>
            <div></div>
            <div><el-input size="mini" v-model="itme.totalquantity" placeholder=""></el-input></div>
            <div><i class="el-icon-minus" @click="ondelete" :data-indexs="index"></i></div>
          </div>
        </div>

        <div class="img_model" @click="preview_img_url=''" v-show="preview_img_url">
          <img :src="preview_img_url" alt="">
        </div>

        <div class="from_box" v-if="this.$route.query.page_style === 'local'">
          <div>
            <span>生產單號：</span>
            <span>{{add_delivery_data.library_code}}</span>
          </div>

          <div>
            <span>產品編號：</span>
            <el-select v-model="expend_id"
                       filterable
                       :filter-method="filter_method"
                       @change="select_product"
                       placeholder="关键字">
              <el-option
                v-for="(item,index) in options_product_list"
                :key="index"
                :label="item.product_name"
                :value="item.expend_id">
              </el-option>
            </el-select>
          </div>

          <div>
            <span>產品名稱：</span>
            <span v-if="pdfdata.length">{{pdfdata[0].product_name}}</span>
          </div>

          <div>
            <span>產品類別：</span>
            <span v-if="pdfdata.length">{{pdfdata[0].category_name}}</span>
          </div>

          <div>
            <span>產品批號：</span>
            <span v-if="pdfdata.length">{{pdfdata[0].product_code_manual}}</span>
          </div>

          <div>
            <span>牙位：</span>
            <el-input v-if="pdfdata.length" v-model="pdfdata[0].warehouse_name" class="input_box"></el-input>
          </div>

          <div>
            <span>修復體類型：</span>
            <el-input v-model="add_delivery_data.prosthesis_type" class="input_box"></el-input>
          </div>

          <div>
            <span>修復數量：</span>
            <el-input v-if="pdfdata.length" v-model="pdfdata[0].totalquantity" class="input_box"></el-input>
          </div>

          <div>
            <span>QR code：</span>
            <span></span>
          </div>

          <div>
            <span>QR code 狀態：</span>
            <span></span>
          </div>

          <div>
            <span>賬單號：</span>
            <el-input v-model="add_delivery_data.odd_numbers" class="input_box"></el-input>
          </div>

          <div>
            <span>賬單金額：</span>
            <el-input v-if="pdfdata.length" v-model="add_delivery_data.order_amount" class="input_box"></el-input>
          </div>

          <div>
            <span>積分：</span>
            <span></span>
          </div>

          <div>
            <span>點數：</span>
            <span></span>
          </div>

          <!--快遞單號-->
          <div>
            <span>{{$store.state.Order_list_fields.kddh.name}}：</span>
            <el-input class="input_box"
              v-model="add_delivery_data.delivery_code"></el-input>
          </div>

          <!--預計完成日期-->
          <div>
            <span>預計完成日期：</span>
            <el-date-picker
              v-model="$store.state.backstage_completion_time"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="請選擇日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="r">
        <!--生產訂單-->
        <div class="flex_order" v-if="this.$route.query.page_style === 'local'">

          <div class="remarksbox"
               v-if="card_custom.bz.status"
               :style="'order:'+card_custom.bz.order">
            <textarea :placeholder="card_custom.bz.name" v-model="add_delivery_data.remarks"></textarea>
          </div>
          <div class="form_box">
            <span class="meassagetitle">客戶名稱</span>
            <!--<el-select v-if="change_customer_name === '1'"-->
                       <!--@change="change_address_list"-->
                       <!--v-model="$store.state.userdata.dentist_name_id" filterable placeholder="请选择">-->
              <!--<el-option-->
                <!--v-for="item in operator"-->
                <!--:key="item.id"-->
                <!--:label="item.realname"-->
                <!--:value="item.id">-->
              <!--</el-option>-->
            <!--</el-select>-->
            <el-select @change="change_address_list"
                       filterable
                       v-model="add_delivery_data.customer_id">
              <el-option
                v-for="item in supplier_list"
                :key="item.company_id"
                :label="item.company_name[0]"
                :value="item.company_id">
              </el-option>
            </el-select>
          </div>
          <div class="form_box">
            <span class="meassagetitle">客戶編號</span>
            <span>{{add_delivery_data.customer_num}}</span>
          </div>
          <div class="form_box">
            <span class="meassagetitle">客戶地址</span>
            <span class="address_box">
               <i class="el-icon-plus" @click="show_add_subsidiaries = true"></i>
                 <el-select v-model="add_delivery_data.sh_detailed_address"
                            placeholder="Select address">
                     <el-option
                       v-for="(item,index) in address_list"
                       :key="index"
                       :label="item"
                       :value="item">
                  </el-option>
                </el-select>
              </span>
          </div>
          <div class="form_box" @click="onsetname('production_order')">
            <span class="meassagetitle">患者姓名</span>
            <span>{{add_delivery_data.contact_name}}<span class="red">&gt;</span></span>
          </div>
          <div class="form_box" @click="onsetphone">
            <span class="meassagetitle">患者手機號</span>
            <span>{{add_delivery_data.customer_phone}}<span class="red">&gt;</span></span>
          </div>
          <!--<div class="form_box">-->
            <!--<span class="meassagetitle">患者姓名</span>-->
            <!--<el-select filterable-->
                       <!--@change="change_customer_list"-->
                       <!--v-model="$store.state.userdata.name">-->
              <!--<el-option-->
                <!--v-for="item in customer_list"-->
                <!--:key="item.customer_id"-->
                <!--:label="item.customer_liaisons"-->
                <!--:value="item.customer_liaisons">-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</div>-->
          <!--<div class="form_box">-->
            <!--<span class="meassagetitle">患者手機號</span>-->
            <!--<span>{{$store.state.userdata.phone}}<span class="red">&gt;</span></span>-->
          <!--</div>-->

          <div class="form_box">
            <span class="meassagetitle">訂單日期</span>
            <span>{{add_delivery_data.create_time_s}}</span>
          </div>
          <div class="form_box">
            <label>
              <span class="meassagetitle">要求日期</span>
              <span class="date_box">
                 <el-date-picker
                   v-model="add_delivery_data.shipping_date"
                   type="date"
                   :picker-options="pickerOptions"
                   value-format="yyyy-MM-dd"
                   placeholder="請選擇日期">
                 </el-date-picker>
              </span>
            </label>
          </div>

          <div class="form_box upfile"
               v-if="card_custom.scfj.status"
               :style="'order:'+card_custom.scfj.order">
            <label for="file">
              <input style="display: none" id="file" type="file" @change="showfile" multiple>
              <span class="meassagetitle">{{card_custom.scfj.name}}</span>
              <span class="filename">{{$store.state.file.name}}<span class="red">&gt;</span></span>
            </label>
          </div>
          <div class="form_box upfile file_voucher"
               v-if="card_custom.scpz.status"
               :style="'order:'+card_custom.scpz.order">
            <label for="file_voucher">
              <input style="display: none" id="file_voucher" type="file" @change="Submission_deposit">
              <span class="meassagetitle">{{card_custom.scpz.name}}</span>
              <span class="filename">{{$store.state.file.name}}<span class="red">&gt;</span></span>
            </label>
          </div>
          <div class="form_box" v-if="itme!==''"
               :style="'order:'+card_custom.scfj.order"
               v-for="(itme,index) in $store.state.enclosure" :key="index">
            <a target="_blank"
               :href="itme">{{itme.split('/')[itme.split('/').length-1]}}</a>
            <span class="filename" @click="deleteflie(itme)">
                <span class="delbut">删除</span>
              </span>
          </div>
          <div class="form_box"
               :style="'order:'+card_custom.scfj.order">
            <a target="_blank" :href="add_delivery_data.enclosure">{{add_delivery_data.enclosure}}</a>
            <!--<span class="filename" @click="deleteflie_local(index)">-->
                <!--<span class="delbut">删除</span>-->
            <!--</span>-->
          </div>
          <div class="form_box signature"
               :style="'order:'+card_custom.dzqm.order"
               v-if="$store.state.userdata.Paymentmethod!==null && card_custom.dzqm.status"
               @click="popupVisible3 = true">
            <span class="meassagetitle">{{card_custom.dzqm.name}}</span>
            <span v-if="$store.state.signature_status === 0" class="el-icon-circle-close not_signed"></span>
            <span v-if="$store.state.signature_status === 1" class="el-icon-circle-check has_signed"></span>
          </div>
        </div>

        <div class="footerbox" v-html="baseinfo.base_sale_intro"></div>
        <div class="butmaxbox">
          <el-dropdown v-if="show_pdf" trigger="click" @command="select_pdf">
                    <span class="el-dropdown-link">
                          <div class="butbox pdf">PREVIEW</div>
                    </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(list,index) in pdf_list"
                                :key="index"
                                :command="[list.templates_id]">
                {{list.templates_title}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="butbox butbox2">
            <a href="javascript:window.print()" target="_self">PRINT</a>
          </div>
          <div class="butbox" @click="onSure(false)">
            Confirm Send
          </div>
          <!--<div v-if="$store.state.userdata.Paymentmethod!==null"-->
          <!--class="butbox SettlementButton"-->
          <!--@click="onsettlement">-->
          <!--结算-->
          <!--</div>-->
        </div>
      </div>
    </div>

    <div v-show="showmode" @click="onhiddenmode" class="pdfimgmode">
      <iframe :src="pdfimgurl"></iframe>
    </div>
  </div>

</template>

<script>
  import ScrollPosition from '../assets/js/scroll-position'
  import {Radio, Button} from 'mint-ui';
  import {
    exportPdf,
    getUserInfo,
    baseInfo,
    delPdf,
    getInstallMode,
    LocalShoppingCart,
    COMID,
    ENTID,
    commitOrderSave,
    curtainlogout,
    uploadFile,
    delOrderFile,
    getusersInfg,
    approval_discount,
    payment_money,
    getSelectionTemplates,
    getshippingMethodList,
    paymentInterface,
    getSubCompany,
    addSubcompany,
    getServiceUser,
    getProClassify,
    getClassifyInstallationSite,
    getProDetail,
    lis,
    customer,
    AccessLibrary,
    exportPdf_library,
  } from '../assets/js/api'
  import Dot from '../assembly/Dot/Dot';
  import Installationfee from '../assembly/Installationfee/Installationfee'
  import Setregion from '../assembly/Setregion/Setregion'
  import {MessageBox, Popup, Toast} from 'mint-ui';

  export default {
    name: "shoppingcart",
    data() {
      return {
        card_custom: this.$store.state.page_state.card_custom,
        show_state1: false,
        show_state2: false,
        show_state3: false,
        popupVisible: false,
        popupVisible2: false,
        popupVisible3: false,
        popupVisible4: false,
        LocalShoppingCart: '',
        total: 0,
        alltotal: 0,
        baseinfo: {},
        deliverymode: [],
        install_value: '',
        pdfdata: [],
        userdata: [],
        pdfimgurl: '',
        showmode: false,
        pdfdatalength: 0,
        deposit_amount: 0,
        discount: 0,
        value: this.$store.state.userdata.Paymentmethod,
        options: [],
        installationfee: 0,
        installation_charge_id: [],
        installation_charge_num: [],
        orderdiscount: this.$store.state.orderdiscount,
        orderdiscountresult: 0,
        order_id: sessionStorage.getItem('order_id') || '',
        lowest_discount: [],  //员工折扣
        audit_preferences: '', //审批优惠
        audit_remarks: '',//审批备注
        signature_method: '1',//电子签署方式
        pdf_list: [],//pdf模板列表
        delivery_method_list: [],//送貨方式
        pickerOptions: {
          disabledDate: (time) => {
            // 不能选择比最快送达的时间还早的时间this.getNewData(this.product_shippingTimeMax)
            if (this.$store.state.delivery_time_value) {
              return time.getTime() <= new Date(this.getNewData(this.$store.state.delivery_time_value)).getTime() - 86400000;
            }
            else {
              return time.getTime() <= Date.now() - 86400000;
            }
          }
        },
        preview_img_url: '',
        duplicate_submission: true, //避免重複提交
        list_class: Number(JSON.parse(localStorage.getItem('userdata')).users_role),
        address_list:[], //子公司地址
        show_add_subsidiaries:false, //是否顯示新增子公司地址的彈框
        add_subsidiaries_data:{     //新增的子公司數據
          scompany_name : '',
          scompany_address : '',
          scompany_customer : '',
          scompany_phone : '',
        },
        DentistName:'',
        operator: [],//醫生列表
        change_customer_name: JSON.parse(localStorage.getItem('userdata')).change_customer_name, //修改醫生的權限
        dentist_name_id:'', // 牙医姓名ID

        classify:[], // 产品分类
        pro_classify_id:'', // 产品分类id

        product_list:[], // 产品列表
        options_product_list:[], // 产品列表

        list:[], // 安装位置
        list2:[], // 安装位置
        list3:[], // 安装位置

        select_list:'',
        select_list2:'',
        select_list3:'',
        Installationlocation:'',//安装位置
        supplier_list:[], //供应商
        customer_list:[], //公司联络人

        expend_id:'',
        add_delivery_data:{
          type : 2, // 產品id
          odd_numbers:'', // 对应后台手动输入单号，賬單號.
          delivery_code:'', // 快遞單號.
          customer_id:'', // 客户公司ID.
          contact_name :'', //  收货人名称(联络人名称)..
          customer_phone :'', //  联系电话
          shipping_date :'', // 送貨日期（出庫
          remarks :'', //备注
          library_id :'', // 编辑库单id (编辑的时候传，目前用于牙医网站).
          enclosure :'', // 附件（注意： base64結構，例：image/jpeg;base64,/9j/4RPbRXhpZg）.

          customer_num :'', // 客户编号.
          sh_detailed_address :'', // 客户地址.
          order_amount :'', // 賬單金額.
          prosthesis_type :'', // prosthesis_type.
        },
        show_pdf:false
      }
    },
    components: {
      MessageBox,
      Popup,
      Dot,
      Radio,
      Installationfee,
      Setregion,
      Button
    },
    mounted() {
      let delivery_details = {}

      if(sessionStorage.getItem('delivery_details')){
        delivery_details = JSON.parse(sessionStorage.getItem('delivery_details'))
        this.add_delivery_data = delivery_details
        // this.add_delivery_data.odd_numbers = delivery_details.odd_numbers
        // this.add_delivery_data.customer_id = delivery_details.customer_id
        // this.add_delivery_data.contact_name = delivery_details.contact_name
        this.add_delivery_data.customer_phone = delivery_details.order_phone
        this.add_delivery_data.shipping_date = delivery_details.ship_date
        // this.add_delivery_data.remarks = delivery_details.remarks
        // this.add_delivery_data.library_id = delivery_details.library_id
        // this.add_delivery_data.enclosure = delivery_details.enclosure
        // this.add_delivery_data.library_code = delivery_details.library_code  // 生产单号.
//        this.add_delivery_data.customer_num = delivery_details.customer_num // 客户编号.


        this.show_pdf = true
        sessionStorage.removeItem('LocalShoppingCart')
//         this.pdfdata = []
        if (delivery_details.pro_s && delivery_details.pro_s.length){
          LocalShoppingCart(delivery_details.pro_s[0].product_id, 1, delivery_details.pro_s[0].product_id, delivery_details.pro_s[0])
        }
      }
      // 获取供应商数据
      lis({size:10000}).then(data => {
        if (data.status && data.data && data.data.length){
          this.supplier_list = data.data
          this.supplier_list.map(itme=>{
            if (itme.company_id === delivery_details.customer_id){
              this.add_delivery_data.customer_num = itme.customer_num
              return
            }
          })
        }
      })
//      公司联络人
      customer().then(data=>{
        if (data.status && data.data){
          this.customer_list = data.data
        }
      })
      getProClassify().then((data)=>{
        data.data.map(itme=>{
          this.product_list = this.product_list.concat(itme.prodetail)
        })
        this.options_product_list = this.product_list

      })

      this.$store.commit('set_delivery_method', '') //清除送貨方式
      //子公司資料
      getSubCompany().then(data=>{
        if (data.status && data.data){
          this.address_list = data.data
          this.address_list.map(itme=>{
            itme.value = `(${itme.scompany_customer}) ${itme.scompany_address}`
          })
          if (this.address_list && this.address_list.length === 1){
            this.$store.state.userdata.Receivingaddress = `(${this.address_list[0].scompany_customer}) ${this.address_list[0].scompany_address}`
          }
        }
      })

      //公司名和销售条款
      baseInfo().then((data) => {
        data.base_sale_intro === undefined ? data.base_sale_intro = '' : ''
        let dom = document.createElement('p')
        dom.innerHTML = data.base_sale_intro
        data.base_sale_intro = dom.innerText
        this.baseinfo = data
        if (sessionStorage.getItem('quotation_code')) {
          this.baseinfo.quotation_code = sessionStorage.getItem('quotation_code')
        }
      })

      // 獲取送貨方式
      getshippingMethodList().then(data => {
        if (data.status) {
          this.delivery_method_list = data.data
        }
      })

      // 获取模板列表
      getSelectionTemplates('warehouse_temp_id').then(data => {
        if (data.status) {
          data.data.tempData.splice(0, 1)
          this.pdf_list = data.data.tempData
        }
      })

      this.changeinstallationfee()

      // 获取员工折扣，获取用户信息
      getusersInfg().then((data) => {
        this.lowest_discount = data.data.lowest_discount
        this.DentistName = data.data.users_realname
        // 获取服务人员.醫生
        getServiceUser().then(data => {
          if (data.status) {
            this.operator = data.data
            // 默認當前醫生
            if (this.operator){
              this.operator.map(item=>{
                if (item.realname === this.DentistName){
                  this.dentist_name_id = this.$store.state.userdata.dentist_name_id || item.id
                }
              })
            }
          }
        })
      })



      // 获取安装方式
      getInstallMode().then((data) => {
        data.map((itme, index) => {
          if (index === this.$store.state.InstallMode) {
            itme.state = true
            this.install_value = itme.name
          }
          else {
            itme.state = false
          }
        })
        this.deliverymode = data
      })
      this.ongetproductInstallationSite()
      this.getLocalShoppingCart()
      //计算折扣
      this.Calculationorderdiscountresult()
      //设置默认时间
      this.gettime()
      // 查看是否有已经审核成功的折扣
      if (sessionStorage.getItem('order_id')) {
        this.Initialization_discount().then(data => {
          if (this.$store.state.orderdiscount_id === 'Approval' && data.data.approval_discount !== '') {
            this.$store.commit('set_approval_discount', data.data.approval_discount) //已同意是审批折扣
            this.$store.commit('set_orderdiscount', data.data.approval_discount)
            this.orderdiscount = data.data.approval_discount
            this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
            this.$store.commit('set_orderdiscount_id', 'Approval') //订单折扣id标识
            this.save_approval() //审核成功保存订单
          }
        })
      }

      ScrollPosition.get.call(this);
    },
    methods: {
      on_return(){
        sessionStorage.removeItem('delivery_details')
        this.$router.go(-1)
      },
      change_customer_list(){
        for (let i=0;i<this.customer_list.length;i++){
          if (this.$store.state.userdata.name === this.customer_list[i].customer_liaisons){
//            this.$store.state.userdata.phone = this.customer_list[i].customer_phone
          }
        }
      },
      change_classify(){
//        this.classify.map(itme=>{
//          if (itme.pro_classify_id === this.pro_classify_id){
//            this.product_list = itme.prodetail
//            this.options_product_list = this.product_list
//          }
//        })
//        this.ongetproductInstallationSite()
      },
      select_product(){
        getProDetail(this.expend_id).then(data=>{
          data.detail.warehouse_name = localStorage.getItem('Installationlocation')
          sessionStorage.removeItem('LocalShoppingCart')
          // this.pdfdata = []
          LocalShoppingCart(data.detail.product_id, 1, data.detail.expend_id, data.detail)
          this.getLocalShoppingCart()
        })
      },
      filter_method(val){
        // product_model
        if (val) { //val存在
          this.options_product_list = this.product_list.filter((item) => {
            if (item.product_model.indexOf(val)> -1 || item.product_name.indexOf(val)> -1) {
              return true
            }
          })
        } else { //val为空时，还原数组
          this.options_product_list = this.product_list;
        }
      },
      change_list(){
        this.list.map(itme=>{
          itme.active = ''
          this.select_list2 = ''
          if (itme.i_id === this.select_list){
            itme.active = 'active'
            this.list2 = itme.child
          }
        })
        this.statistics_installation()
      },
      change_list2(){
        this.list2.map(itme=>{
          itme.active = ''
          this.select_list3 = ''
          if (itme.i_id === this.select_list2){
            itme.active = 'active'
            this.list3 = itme.child
          }
        })
        this.statistics_installation()
      },
      change_list3(){
        this.list3.map(itme=>{
          itme.active = ''
          if (itme.i_id === this.select_list3){
            itme.active = 'active'
          }
        })
        this.statistics_installation()
      },
      //統計安裝位置
      statistics_installation() {
        this.Installationlocation = ''
        this.list.map((itme) => {
          if (itme.active) {
            if (itme.child.length) {
              this.Installationlocation += itme.i_name + ' '
            }
            if (itme.other){
              this.Installationlocation += itme.other + ' '
            }
            if (itme.child.length) {
              itme.child.map(list => {
                if (list.active) {
                  this.Installationlocation += list.i_name + ' '
                  if (list.child.length){
                    list.child.map(list2=>{
                      if (list2.active) {
                        this.Installationlocation += list2.i_name + ' '
                      }
                    })
                  }
                }
              })
            }
            this.Installationlocation +=  ', '
          }
        })
        localStorage.setItem('Installationlocation', this.Installationlocation)
      },
      ongetproductInstallationSite() {
        getClassifyInstallationSite(this.pro_classify_id).then((data) => {
          if (data.status) {
            data.data.map(itme => {
              itme.child = []
              if (itme.i_pid === '0') {
                itme.show_input_child = false
                itme.other = ''
                this.list.push(itme)
              }
            })
            // 整理二級安裝位置
            data.data.map(itme => {
              this.list.map(list => {
                if (itme.i_pid !== '0' && itme.i_pid === list.i_id) {
                  itme.active = ''
                  itme.show_child = false
                  itme.show_input_child = false
                  itme.other = ''
                  list.child.push(itme)
                }
              })
            })
            // 整理三級安裝位置
            data.data.map(itme => {
              this.list.map(list => {
                list.child.map(list2=>{
                  if (itme.i_pid !== '0' && itme.i_pid === list2.i_id) {
                    itme.active = ''
                    list2.child.push(itme)
                  }
                })

              })
            })

            // 第一層的排序
            this.list.sort((a, b) => {
              return a.i_sort - b.i_sort
            })
            // 第二層的排序
            this.list.map(itme=>{
              if (itme.child){
                itme.child.sort((a, b) => {
                  return a.i_sort - b.i_sort
                })
                // 第三層的排序
                itme.child.map(list=>{
                  list.child.sort((a, b) => {
                    return a.i_sort - b.i_sort
                  })
                })
              }
            })
          }
        })
      },
      // 修改醫生的時候同時修改地址列表
      change_address_list(){
        console.log(this.address_list)
        this.supplier_list.map(itme=>{
          if (itme.company_id === this.add_delivery_data.customer_id){
            this.address_list = itme.company_address
            this.add_delivery_data.sh_detailed_address = itme.company_address[0]
            this.add_delivery_data.customer_num = itme.customer_num
          }
        })
        //子公司資料
        // getSubCompany(this.dentist_name_id).then(data=>{
        //   if (data.status && data.data){
        //     this.address_list = data.data
        //     this.address_list.map(itme=>{
        //       itme.value = `(${itme.scompany_customer}) ${itme.scompany_address}`
        //     })
        //     if (this.address_list && this.address_list.length === 1){
        //       this.$store.state.userdata.Receivingaddress = `(${this.address_list[0].scompany_customer}) ${this.address_list[0].scompany_address}`
        //     }
        //   }
        // })
      },
      // 增加子公司
      add_subsidiaries(){
        // console.log(this.add_subsidiaries_data)
        addSubcompany(this.add_subsidiaries_data).then(data=>{
          // console.log(data)
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.msg,
            }).then(() => {
            });
          }
          else {
            this.$alert(data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          if (data.status){
            // 清除數據
            this.add_subsidiaries_data.scompany_name = ''
            this.add_subsidiaries_data.scompany_address = ''
            this.add_subsidiaries_data.scompany_customer = ''
            this.add_subsidiaries_data.scompany_phone = ''
            this.show_add_subsidiaries = false
            getSubCompany().then(data=>{
              // console.log(data)
              if (data.status && data.data){
                this.address_list = data.data
                this.address_list.map(itme=>{
                  itme.value = `(${itme.scompany_customer}) ${itme.scompany_address}`
                })
              }
            })
          }
        })
      },
      select_delivery_method() {
        this.delivery_method_list.map(data => {
          if (data.shipping_id === this.$store.state.delivery_method) {
            this.$store.commit('set_delivery_time_value', data.delivery_time_value)
            this.$store.commit('setDeliverytime', {datevalue: ''})
          }
        })
      },
      getNewData(days) {
        if (!days) {
          return ''
        }
        else {
          let dates = new Date();
          let nDate = new Date((dates.getMonth() + 1) + '-' + dates.getDate() + '-' + dates.getFullYear()); //转换为MM-DD-YYYY格式
          let millSeconds = Math.abs(nDate) + (days * 24 * 60 * 60 * 1000);
          let rDate = new Date(millSeconds);
          let year = rDate.getFullYear();
          let month = rDate.getMonth() + 1;
          if (month < 10) month = "0" + month;
          let date = rDate.getDate();
          if (date < 10) date = "0" + date;
          let d = (year + "-" + month + "-" + date)
          if (d === 'NaN-NaN-NaN') {
            d = ''
          }
          return d;
        }
      },
      //展開pdf模板
      select_pdf(command) {
        this.ongetpdf(command[0])
      },
      // 选择签署
      select_signature() {
        // 订单状态已签署不能提交订单
        if (this.$store.state.quotation_ifshow !== '1') {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '已签署订单不能修改',
            }).then(() => {
            });
          }
          else {
            this.$alert('已签署订单不能修改', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          return
        }
        let id = sessionStorage.getItem('order_id')
        this.popupVisible4 = false
        if (this.signature_method === '2') {

          let oInput = document.createElement('input');
          let host = window.location.host
          oInput.value = 'http://' + host + '/web/dist/#/signature?id=' + id;
          document.body.appendChild(oInput);
          oInput.select(); // 选择对象
          document.execCommand("Copy");
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '已複製',
            }).then(() => {

            });
          }
          else {
            this.$alert('已複製', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        }
        else {
          this.$router.push({path: '/signature?id=' + id + '&back=1'});
        }
      },
      // 审核优惠
      input_audit_preferences() {
        this.popupVisible3 = !this.popupVisible3
      },
      // 提交审批
      submit_audit() {
        this.popupVisible3 = !this.popupVisible3
        if (sessionStorage.getItem('order_id')) {
          let audit_obj = {
            order_id: sessionStorage.getItem('order_id'),
            discount: this.audit_preferences,
            remarks: this.audit_remarks,
            order_amount: this.total,
          }
          approval_discount(audit_obj).then(data => {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: data.message,
              }).then(() => {
                // this.popupVisible = !this.popupVisible
              });
            }
            else {
              this.$alert(data.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  // this.popupVisible = !this.popupVisible
                }
              });
            }

            if (data.status) {
              let state = data.data.curt_discount.approval_status
              if (data.data.approval_discount !== '') {
                this.$store.commit('set_approval_discount', data.data.approval_discount) //已同意是审批折扣
                this.$store.commit('set_orderdiscount', data.data.approval_discount)
                this.orderdiscount = data.data.approval_discount
                this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
                this.$store.commit('set_orderdiscount_id', 'Approval') //订单折扣id
                this.save_approval() //审核成功保存订单
              }
              if (Number(state) === 1) {
                let s = 0
                let ds = setInterval(() => {
                  this.Initialization_discount(this.audit_preferences).then((g) => {
                    s += 120000
                    if (g.data.curt_discount.approval_status !== '1' || s >= 1800000) {
                      clearInterval(ds)
                      if (g.data.curt_discount.approval_status === '2') {
                        this.$store.commit('set_approval_discount', g.data.approval_discount) //已同意是审批折扣
                        this.$store.commit('set_orderdiscount', g.data.approval_discount)
                        this.orderdiscount = g.data.approval_discount
                        this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
                        this.$store.commit('set_orderdiscount_id', 'Approval') //订单折扣id
                        this.save_approval() //审核成功保存订单
                      }
                      let message;
                      if (s >= 1800000) {
                        message = '等待審批超時'
                      }
                      else {
                        message = g.message
                      }
                      if (this.$store.state.client) {
                        MessageBox({
                          title: '提示',
                          message: message,
                        }).then(() => {
                        });
                      }
                      else {
                        this.$alert(message, '提示', {
                          confirmButtonText: '确定',
                          callback: action => {
                          }
                        });
                      }
                    }
                  })
                }, 120000)
              }
            }
            else {

            }
          })
        }
        else {
          this.save_approval().then(() => {
            let audit_obj = {
              order_id: sessionStorage.getItem('order_id'),
              discount: this.audit_preferences,
              remarks: this.audit_remarks,
              order_amount: this.total,
            }
            approval_discount(audit_obj).then(data => {
              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: data.message,
                }).then(() => {
                  // this.popupVisible = !this.popupVisible
                });
              }
              else {
                this.$alert(data.message, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    // this.popupVisible = !this.popupVisible
                  }
                });
              }

              if (data.status) {
                let state = data.data.curt_discount.approval_status
                if (data.data.approval_discount !== '') {
                  this.$store.commit('set_approval_discount', data.data.approval_discount) //已同意是审批折扣
                  this.$store.commit('set_orderdiscount', data.data.approval_discount)
                  this.orderdiscount = data.data.approval_discount
                  this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
                  this.$store.commit('set_orderdiscount_id', 'Approval') //订单折扣id
                  this.save_approval() //审核成功保存订单
                }
                if (Number(state) === 1) {
                  let s = 0
                  let ds = setInterval(() => {
                    this.Initialization_discount(this.audit_preferences).then((g) => {

                      s += 120000
                      if (g.data.curt_discount.approval_status !== '1' || s >= 1800000) {
                        clearInterval(ds)
                        if (g.data.curt_discount.approval_status === '2') {
                          this.$store.commit('set_approval_discount', g.data.approval_discount) //已同意是审批折扣
                          this.$store.commit('set_orderdiscount', g.data.approval_discount)
                          this.orderdiscount = g.data.approval_discount
                          this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
                          this.$store.commit('set_orderdiscount_id', 'Approval') //订单折扣id
                          this.save_approval() //审核成功保存订单
                        }
                        let message;
                        if (s >= 1800000) {
                          message = '等待審批超時'
                        }
                        else {
                          message = g.message
                        }
                        if (this.$store.state.client) {
                          MessageBox({
                            title: '提示',
                            message: message,
                          }).then(() => {
                          });
                        }
                        else {
                          this.$alert(message, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                          });
                        }
                      }
                    })
                  }, 120000)
                }
              }
              else {

              }
            })
          })
        }
      },
      // 轮询时和初始化时调用的接口
      Initialization_discount(audit_preferences) {
        return new Promise((resolve, reject) => {
          let audit_obj = {
            order_id: sessionStorage.getItem('order_id'),
            order_amount: this.total,
            discount: audit_preferences,
          }
          approval_discount(audit_obj).then(data => {
            if (data.status) {
              resolve(data)
            }
            else {
              reject(data)
            }

          })
        })
      },
      // 删除附件
      deleteflie(filename) {
        delOrderFile(sessionStorage.getItem('order_id'), filename).then((data) => {
          if (data.status) {
            this.$store.state.enclosure.map((itme, index) => {
              if (itme === filename) {
                this.$store.state.enclosure.splice(index, 1)
              }
            })
          }
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.message,
            }).then(res => {
            })
          }
          else {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        })
      },
      // 刪除本地附件
      deleteflie_local(index) {
        if (this.$store.state.client) {
          MessageBox({
            title: '提示',
            message: 'Whether confirm delete?',
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then((confirm) => {
            this.$store.state.file.splice(index, 1)
            if (confirm === 'confirm')
              MessageBox({
                title: '提示',
                message: '删除成功',
              }).then(res => {
              })
          });
        }
        else {
          this.$confirm('Whether confirm delete?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            this.$store.state.file.splice(index, 1)
            this.$alert('删除成功', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }).catch((c) => {
          });
        }
      },
      showfile() {
        let reader = new FileReader()
        let _this = this
        reader.readAsDataURL(document.getElementById('file').files[0])
        reader.onload = function () {
          _this.add_delivery_data.enclosure = this.result.toString()
        }
        if (sessionStorage.getItem('order_id')) {
          this.$store.commit('set_file', {name: ''}) //保存文件
          for (let i = 0; i < document.getElementById('file').files.length; i++) {
            let formData = new window.FormData()
            formData.append('file', document.getElementById('file').files[i])
            formData.append('id', sessionStorage.getItem('order_id'))
            let fileName = this.$store.state.loginuserdata.username + '_' + this.getNowTime() + '_' + (i + 1)
            formData.append('fileName', fileName)
            uploadFile(formData).then((data) => {
              if (data.status) {
                this.$store.commit('set_enclosure', data.file_path) //订单附件
                if (this.$store.state.client) {
                  MessageBox({
                    title: '提示',
                    message: data.message,
                  }).then(() => {
                  });
                }
                else {
                  this.$alert(data.message, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                }
              }
              else {
                if (this.$store.state.client) {
                  MessageBox({
                    title: '提示',
                    message: '上传失败',
                  }).then(() => {
                  });
                }
                else {
                  this.$alert('上传失败', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                }
              }
            })
          }

        }
        else {
          this.$store.commit('set_file', [].slice.call(document.getElementById('file').files)) //保存文件
        }
      },
      getNowTime() {
        // 加0
        function add_10(num) {
          if (num < 10) {
            num = '0' + num
          }
          return num;
        }

        let myDate = new Date();
        let nowTimes = myDate.getFullYear() + '-' + add_10(myDate.getMonth() + 1) + '-' + myDate.getDate() + '_' + add_10(myDate.getHours()) + ':' + add_10(myDate.getMinutes()) + ':' + add_10(myDate.getSeconds());
        return nowTimes;
      },
      // 提交订单时提交附件
      OrderAnnex(datas) {
        for (let i = 0; i < this.$store.state.file.length; i++) {
          let formData = new window.FormData()
          formData.append('file', this.$store.state.file[i])
          formData.append('id', datas.order_id)
          let fileName = this.$store.state.loginuserdata.username + '_' + this.getNowTime() + '_' + (i + 1)
          formData.append('fileName', fileName)
          uploadFile(formData).then((data) => {
            if (data.status) {
              this.$store.commit('set_enclosure', data.file_path) //订单附件
              this.$store.commit('set_file', {name: ''}) //保存文件
            }
          })
        }
      },
      //计算合共（产品合共+运输费+安装费）
      computed_alltotal() {
        this.alltotal = (this.total + this.$store.state.shippingcost + this.installationfee)
      },
      // 计算安装费&拼装安装费的ID
      changeinstallationfee() {
        if (this.$store.state.userdata.installationfee) {
          this.installationfee = 0
          this.installation_charge_id = []
          this.installation_charge_num = []
          this.$store.state.userdata.installationfee.map(itme => {
            if (itme.state === undefined) {
              this.installationfee += (Number.parseFloat(itme.i_price)) * Number.parseFloat(itme.num)
              this.installation_charge_id.push(itme.i_id)
              this.installation_charge_num.push(itme.num)
            }
            else {
              if (itme.state) {
                this.installationfee += (Number.parseFloat(itme.i_price)) * Number.parseFloat(itme.num)
                this.installation_charge_id.push(itme.i_id)
                this.installation_charge_num.push(itme.num)
              }
            }
          })
        }
        //计算合共
        this.computed_alltotal()
      },
      edit(index) {
        this.$router.push({path: '/productedit?index=' + index});
      },
      gettime() {
        if (this.$store.state.userdata.Deliverytime === '') {
          getUserInfo(1).then((data) => {
            let myDate = new Date();
            let defaultmyDate = myDate.getFullYear();
            defaultmyDate += '-' + (myDate.getMonth() + 1);
            defaultmyDate += '-' + myDate.getDate();
            let arr = data.userinfo.delivery_time
            let obj = {
              time: arr[0],
              time_type: 1,
              datevalue: defaultmyDate,
            }
            this.$store.commit('setDeliverytime', obj)
          })
        }
      },
      inorderlist() {
        this.$store.commit('set_inorderilstroutername', 'shoppingcart?id=' + this.$route.query.id)
        this.$router.push({path: '/orderlist'});
      },
      reopenNewOrder() {
        sessionStorage.removeItem('LocalShoppingCart');
        sessionStorage.removeItem('order_id');
        sessionStorage.removeItem('quotation_code');
        this.$store.commit('res_state')
        this.$router.push({path: '/index'});
      },
      showPersonalCenter() {
        this.popupVisible ? this.popupVisible = false : this.popupVisible = true
      },
      curtainlogout() {
        curtainlogout().then(data => {
          sessionStorage.removeItem('LocalShoppingCart');
          sessionStorage.removeItem('order_id');
          sessionStorage.removeItem('quotation_code');
          localStorage.removeItem('logindata');
          localStorage.removeItem('userdata');
          this.$store.commit('res_state')
          this.$router.push({path: '/'});
        })
      },
      ondelete(e) {
        if (this.$store.state.client) {
          MessageBox({
            title: '提示',
            message: '您确定删除產品吗？',
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then((confirm) => {
            if (confirm === 'confirm'){
              LocalShoppingCart(0, 0, 0, 0, e.target.getAttribute('data-indexs'))
              this.pdfdata = []
              this.total = 0
              this.getLocalShoppingCart()
            }
          });
        }
        else {
          this.$confirm('您确定删除產品吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            LocalShoppingCart(0, 0, 0, 0, e.target.getAttribute('data-indexs'))
            this.pdfdata = []
            this.total = 0
            this.getLocalShoppingCart()
          }).catch((c) => {
          });
        }

      },
      onshowchildattribute(e) {
        if (e.target.getAttribute('data-f')) return
        if (e.target.getAttribute('data-p') === 'p') {
          if (e.target.className === 'showattribute') {
            e.target.className = ''
          }
          else {
            e.target.className = 'showattribute'
          }
        }
        else {
          if (e.target.parentNode.className === 'showattribute') {
            e.target.parentNode.className = ''
          }
          else {
            e.target.parentNode.className = 'showattribute'
          }
        }
      },
      getLocalShoppingCart() {
        this.LocalShoppingCart = JSON.parse(sessionStorage.getItem('LocalShoppingCart')) || []
        this.pdfdata = []
        this.LocalShoppingCart.map((itme) => {
          // itme.partsData.map((list)=>{
          //   list.active = 1
          // })
          this.pdfdata.push({
            'attribute_group_id': itme.attribute_group_id,
            'productid': itme.product_id,
            'expend_id': itme.expend_id,
            'productprice': itme.expend_price,
            'goods_remark': itme.goods_remark,
            'currency_symbol': itme.currency_symbol,
            'product_formula_id': itme.product_formula_id,
            'totalquantity': itme.sum,
            'product_formula_result_value': itme.result,
            'product_name': itme.product_name,
            'formula_handle': itme.formula_handle,
            'attributeData': itme.attributeData,
            'remarks': itme.remarks,
            'warehouse_name': itme.warehouse_name,
            'product_model': itme.product_model,
            'product_parts_num': itme.product_parts_proid ? itme.product_parts_proid.split(',').length : 0,
            'partsData': itme.partsData || [],
            'active': 1,
            'unit_price': itme.unit_price,
            'product_installation_charge': itme.product_installation_charge,
            'product_minimum_discount': itme.product_minimum_discount,
            'canvas_img_data': itme.canvas_img_data, //繪圖（base64格式）
            'category_name': itme.category_name, //類別
            'product_code_manual': itme.product_code_manual, //批號?
          })
        })
        console.log(this.pdfdata)
        // 循环主产品
        this.pdfdatalength = 0 //主产品数量
        this.discount = 0
        if (!this.pdfdata) {
          return
        }
        this.pdfdata.map((itme) => {
          this.total += (itme.product_formula_result_value * itme.totalquantity) + Number.parseFloat(itme.product_installation_charge * itme.totalquantity)
          this.pdfdatalength += Number.parseInt(itme.totalquantity)
          this.discount += Math.ceil(((itme.product_minimum_discount / 100) * itme.product_formula_result_value) * itme.totalquantity)
          // 循环配件
          if (!itme.partsData) {
            return
          }
          itme.partsData.map((list) => {
            this.total += (list.parts_formula_result_value * list.totalquantity) + Number.parseFloat(list.product_installation_charge * list.totalquantity)
            // 循环二级配件
            if (!list.partsInPartsData) {
              return
            }
            list.partsInPartsData.map((list2) => {
              list2.state = false
              this.total += (list2.parts_formula_result_value * list2.totalquantity) + Number.parseFloat(list2.product_installation_charge * list2.totalquantity)
              // 循环三级配件
              if (!list2.partsInPartsData) {
                return
              }
              list2.partsInPartsData.map((list3) => {
                list3.state = false
                this.total += (list3.parts_formula_result_value * list3.totalquantity) + Number.parseFloat(list3.product_installation_charge * list3.totalquantity)
                // 循环四级配件
                if (!list3.partsInPartsData) {
                  return
                }
                list3.partsInPartsData.map((list4) => {
                  list4.state = false
                  this.total += (list4.parts_formula_result_value * list4.totalquantity) + Number.parseFloat(list4.product_installation_charge * list4.totalquantity)
                  // 循环五级配件
                  if (!list4.partsInPartsData) {
                    return
                  }
                  list4.partsInPartsData.map((list5) => {
                    list5.state = false
                    this.total += (list5.parts_formula_result_value * list5.totalquantity) + Number.parseFloat(list5.product_installation_charge * list5.totalquantity)
                    // 循环第六级配件
                    if (!list5.partsInPartsData) {
                      return
                    }
                    list5.partsInPartsData.map((list6) => {
                      list6.state = false
                      this.total += (list6.parts_formula_result_value * list6.totalquantity) + Number.parseFloat(list6.product_installation_charge * list6.totalquantity)
                    })
                  })
                })
              })
            })
          })
        })
        //计算合共
        this.computed_alltotal()
        this.Calculationorderdiscountresult()
      },
      Calculationorderdiscountresult() {
        let orderdiscount_id = ''
        if (this.lowest_discount) {
          this.lowest_discount.map(itme => {
            if (itme.value === this.orderdiscount) {
              orderdiscount_id = itme.id
            }
          })
        }
        this.$store.commit('set_orderdiscount', this.orderdiscount)
        this.$store.commit('set_orderdiscount_id', orderdiscount_id) //订单折扣id
        this.orderdiscountresult = Math.ceil(this.total * (this.orderdiscount / 100)).toFixed(2)
      },
      onshowchild(e) {
        this.pdfdata.map((itme, index) => {
          if (index === Number.parseInt(e.target.getAttribute('data-index'))) {
            if (itme.active === 0) {
              itme.active = 1
            }
            else {
              itme.active = 0
            }
          }
        })
      },
      onshowchild_child(e) {
        let i = e.target.getAttribute('data-childindex')
        let i2 = e.target.getAttribute('data-childindex2')
        if (this.pdfdata[i] === undefined || this.pdfdata[i].partsData[i2] === undefined) {
          return
        }
        if (this.pdfdata[i].partsData[i2].active === 1) {
          this.pdfdata[i].partsData[i2].active = 0
        }
        else {
          this.pdfdata[i].partsData[i2].active = 1
        }

        this.$set(this.pdfdata, i, this.pdfdata[i])
      },
      onopensetaddress() {
        if (this.$store.state.userdata.time_type === 0) {
          Toast('請先選擇安裝時間');
        }
        else {
          this.$router.push({path: '/setregion?id=' + this.$route.query.id});
        }
      },
      onsetname() {
        if (this.$store.state.client) {
          MessageBox.prompt('Patient name', '', {inputValue: this.add_delivery_data.contact_name}).then(({value, action}) => {
            if (action === 'confirm') {
              this.$store.commit('setname', value)
            }
          }).catch((rejected) => {
          });
        }
        else {
          this.$prompt('Patient  name', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: this.add_delivery_data.contact_name,
          }).then(({value}) => {
//            this.$store.commit('setname', value)
            this.add_delivery_data.contact_name = value
          }).catch(() => {
          });
        }
      },
      onsetage() {
        if (this.$store.state.client) {
          MessageBox.prompt('Patient age', '', {
            inputValue: this.$store.state.userdata.age,
            inputPattern:/^[0-9]*$/,    //正则条件
          }).then(({value, action}) => {
            if (action === 'confirm') {
              this.$store.commit('set_age', value)
            }
          }).catch((rejected) => {
          });
        }
        else {
          this.$prompt('Patient age', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: this.$store.state.userdata.age,
            inputPattern:/^[0-9]*$/,    //正则条件
          }).then(({value}) => {
            this.$store.commit('set_age', value)
          }).catch(() => {
          });
        }
      },
      onsetphone() {
        if (this.$store.state.client) {
          MessageBox.prompt('請輸入電話', '提示', {inputValue: this.add_delivery_data.customer_phone}).then(({value, action}) => {
            if (action === 'confirm') {
              this.$store.commit('setphone', value)
            }
          }).catch((rejected) => {
          });
        }
        else {
          this.$prompt('請輸入電話', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: this.add_delivery_data.customer_phone,
          }).then(({value}) => {
//            this.$store.commit('setphone', value)
            this.add_delivery_data.customer_phone = value
          }).catch(() => {
          });
        }

      },
      onsetemail() {
        if (this.$store.state.client) {
          MessageBox.prompt('請輸入邮箱', '提示', {inputValue: this.$store.state.userdata.email}).then(({value, action}) => {
            if (action === 'confirm') {
              this.$store.commit('setemail', value)
            }
          }).catch((rejected) => {
          });
        }
        else {
          this.$prompt('請輸入郵箱', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: this.$store.state.userdata.email,
          }).then(({value}) => {
            this.$store.commit('setemail', value)
          }).catch(() => {
          });
        }

      },
      ontime_type(e) {
        this.deliverymode.map((itme, index) => {
          itme.state = false;
          if (Number.parseInt(e.target.getAttribute('data-id')) === itme.id) {
            itme.state = true;
            this.install_value = itme.name
            this.$store.commit('set_InstallMode', index)
          }
        })
      },
      ongetpdf(templates_id) {
        let p_data = {
          templates_id: templates_id,
          id: '',
        }
        if(sessionStorage.getItem('delivery_details')){
          let delivery_details = JSON.parse(sessionStorage.getItem('delivery_details'))
          p_data.id = delivery_details.library_id
        }
        exportPdf_library(p_data).then(data=>{
          this.showmode = true
          this.pdfimgurl = data.filePath
          if (!navigator.userAgent.match(/(phone|UC|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
            // window.open(this.pdfimgurl, '_blank')
          }
          else {
            // window.open(this.pdfimgurl, '_self')
          }
        }).catch((e) => {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '請求出錯',
            })
          }
          else {
            this.$alert('請求出錯', '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      onhiddenmode() {
        this.showmode = false
        delPdf(this.pdfimgurl).then((data) => {
          console.log(data)
        })
      },
      onSure(templates_id) {
        //未登录不让提交订单
        let logindata = JSON.parse(localStorage.getItem('logindata'))
        if (!logindata) {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '您尚未登录，请前往登录',
            }).then(res => {
              this.$router.push({path: '/'});
            })
          }
          else {
            this.$alert('您尚未登录，请前往登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push({path: '/'});
              }
            });
          }
          return
        }
        // 没有产品禁止提交
        if (!JSON.parse(sessionStorage.getItem('LocalShoppingCart')) || !JSON.parse(sessionStorage.getItem('LocalShoppingCart')).length  && this.$route.query.page_style !== 'local') {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '您未添加任何产品,请前往添加',
            }).then(res => {
              this.$router.push({path: '/index'});
            })
          }
          else {
            this.$alert('您未添加任何产品,请前往添加', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push({path: '/index'});
              }
            });
          }
          return
        }
        //避免重複提交
        if (this.duplicate_submission) {
          this.duplicate_submission = false
          this.save(logindata, templates_id)
        }
      },
      // 结算按钮,订单已经提交后才可结算
      onsettlement(next) {
        // 订单状态已签署不能提交订单
        if (this.$store.state.quotation_ifshow !== '1') {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '已签署订单不能修改',
            }).then(() => {
            });
          }
          else {
            this.$alert('已签署订单不能修改', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          return
        }
        paymentInterface().then((data) => {
          if (data.status) {
            this.options = data.userinfo
          }
        })
        if (!next) {
          if (this.value === '') {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '請選擇一種支付方式',
              }).then(res => {
              })
            }
            else {
              this.$alert('請選擇一種支付方式', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
          else {
            if (this.$store.state.client) {
              MessageBox.prompt('請輸入定金金额', '提示', {
                inputValue: '',
                closeOnClickModal: false,
                inputType: 'Number'
              }).then(({value, action}) => {
                if (action === 'confirm') {

                  if (this.$store.state.deposit_amount + Number.parseFloat(value) > Number.parseFloat(this.PostDiscountPrice)) {
                    MessageBox({
                      title: '提示',
                      message: '支付金額不能大於餘款',
                    }).then(res => {
                    })
                  }
                  else {
                    // this.$store.commit('setPaymentmethod',this.value) //支付方式
                    // this.$store.commit('set_deposit_amount',value) //定金金额
                    this.deposit_amount = Number.parseFloat(value)
                    this.$store.commit('set_send_mail_flag', 1) //发送邮件标识
                    // 调用附件上传功能
                    MessageBox({
                      title: '提示',
                      message: '是否拍照存證',
                      confirmButtonText: '是',
                      cancelButtonText: '否',
                      showCancelButton: true
                    }).then(res => {
                      if (res === 'confirm') {
                        document.querySelector('#file_voucher').click()
                      }
                      else {
                        this.onfile_Submission_deposit()
                      }
                    })
                    // this.onSure()
                  }
                }
              }).catch((rejected) => {
                // this.$store.commit('setPaymentmethod','') //支付方式
                // this.$store.commit('set_deposit_amount',0) //定金金额
                this.deposit_amount = 0
                this.$store.commit('set_send_mail_flag', 0) //发送邮件标识
              });
            }
            else {
              this.$prompt('請輸入定金金额', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: '',
                inputType: 'Number',
              }).then(({value}) => {
                if (this.$store.state.deposit_amount + Number.parseFloat(value) > Number.parseFloat(this.PostDiscountPrice)) {
                  this.$alert('支付金額不能大於餘款', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                }
                else {
                  this.deposit_amount = Number.parseFloat(value)
                  this.$confirm('是否拍照存證', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    callback: action => {
                      if (action !== 'cancel') {
                        document.querySelector('#file_voucher').click()
                        // this.onSure()
                      }
                      else {
                        this.onfile_Submission_deposit()
                      }
                    }
                  });
                }
              }).catch(() => {
                this.deposit_amount = 0
                this.$store.commit('set_send_mail_flag', 0) //发送邮件标识
              });
            }
          }
        }
        else {
          this.popupVisible2 ? this.popupVisible2 = false : this.popupVisible2 = true
        }
      },
      //取消选择支付方式
      onreturn() {
        this.value = ''
        this.popupVisible2 ? this.popupVisible2 = false : this.popupVisible2 = true
      },
      //提交新单
      Openingneworders(logindata) {
        baseInfo().then((data) => {
          this.baseinfo = data
          let OrderToQuotationdata = this.data()
          OrderToQuotationdata.user_id = logindata
          OrderToQuotationdata.quotation_total_quantity = this.pdfdatalength
          console.log(OrderToQuotationdata)
          commitOrderSave(OrderToQuotationdata).then((datas) => {
            // 成功
            if (datas.status) {
              if (!sessionStorage.getItem('order_id')) {
                this.OrderAnnex(datas)
              }

              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: datas.message,
                }).then(() => {
                  sessionStorage.removeItem('LocalShoppingCart');
                  sessionStorage.removeItem('order_id');
                  sessionStorage.removeItem('quotation_code');
                  this.$store.commit('res_state')
                  this.$router.push({path: '/index'});
                });
              }
              else {
                this.$alert(datas.message, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    sessionStorage.removeItem('LocalShoppingCart');
                    sessionStorage.removeItem('order_id');
                    sessionStorage.removeItem('quotation_code');
                    this.$store.commit('res_state')
                    this.$router.push({path: '/index'});
                  }
                });
              }
            }
            // 失败
            else {
              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: datas.message,
                })
              }
              else {
                this.$alert(datas.message, '提示', {
                  confirmButtonText: '确定',
                });
              }
            }
          }).catch(() => {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '請求出錯',
              })
            }
            else {
              this.$alert('請求出錯', '提示', {
                confirmButtonText: '确定',
              });
            }
          })
        })
      },
      //保存|修改
      save() {
        if (this.pdfdata.length){
          this.add_delivery_data.data = [{
            product_id : this.pdfdata[0].productid,// 产品
            totalquantity : 1, // 數量
          }]
        }

//        console.log(this.add_delivery_data,'??')
        AccessLibrary(this.add_delivery_data).then((datas) => {
          this.duplicate_submission = true
          if (datas.status) {
            this.$router.push({path: '/orderlist/delivery'});
            this.popupVisible2 = false
          }
          else {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: datas.msg,
              })
            }
            else {
              this.$alert(datas.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
          }
        }).catch(() => {
          this.duplicate_submission = true
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '請求出錯',
            })
          }
          else {
            this.$alert('請求出錯', '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      },
      // 审核成功保存订单/审核时订单未提交时保存订单
      save_approval() {
        return new Promise((resolve, reject) => {
          let OrderToQuotationdata = this.data()
          OrderToQuotationdata.user_id = JSON.parse(localStorage.getItem('userdata')).username
          OrderToQuotationdata.quotation_total_quantity = this.pdfdatalength
          OrderToQuotationdata.order_id = sessionStorage.getItem('order_id') ? sessionStorage.getItem('order_id') : ''
          console.log(OrderToQuotationdata)
          commitOrderSave(OrderToQuotationdata).then((datas) => {
            if (datas.status) {
              if (!sessionStorage.getItem('order_id')) {
                // 没有订单id时才提交附件
                this.OrderAnnex(datas)
              }
              this.order_id = datas.order_id
              sessionStorage.setItem('order_id', datas.order_id);
              sessionStorage.setItem('quotation_code', this.baseinfo.quotation_code);
              this.$store.commit('setPaymentmethod', datas.order_id) //订单id
              this.$store.commit('set_send_mail_flag', 0) //发送邮件标识
              resolve(datas)
            }
          })
        })
      },
      data() {
        this.$store.commit('setPaymentmethod', this.value) //支付方式
        this.$store.commit('set_deposit_amount', this.deposit_amount) //定金金额
        return {
          'send_mail_flag': this.$store.state.send_mail_flag,
          'pdf_file_path': '',
          'customer_liaisons': this.$store.state.userdata.name,
          'customer_tel': this.$store.state.userdata.phone,
          'customer_email': this.$store.state.userdata.email,
          'select_date': this.$store.state.userdata.datevalue,
          'select_time_interval': this.$store.state.userdata.Deliverytime,
          'expected_installation_date': this.$store.state.userdata.datevalue,
          'detailed_address': this.$store.state.userdata.Receivingaddress,
          'latLngData': this.$store.state.userdata.latLngData,
          'payment_note': this.$store.state.userdata.Paymentmethod || this.value,
          'currency_symbol': "$",
          'install_value_id': this.$store.state.InstallMode + 1,
          'quotation_total_price': this.PostDiscountPrice,
          'enterprise_id': ENTID,
          'company_id': COMID,
          'quotation_code': this.baseinfo.quotation_code,
          'urgent': this.$store.state.urgent ? 1 : 0,
          'shippingcost': this.$store.state.shippingcost, //运输费
          'shippingcost_id': this.$store.state.freight.toString(), //运输费id
          'productData': this.pdfdata,
          'deposit_amount': this.$store.state.deposit_amount || this.deposit_amount, //定金
          'installation_charge_money': this.installationfee, //安装费
          'installation_charge_id': this.installation_charge_id.toString(), //安装费id
          'installation_charge_number': this.installation_charge_num.toString(), //安装费数量
          'discount': this.orderdiscountresult, //订单折扣
          'discount_id': this.$store.state.orderdiscount_id, //订单折扣id
          'discount_product': this.discount, //产品折扣
          'remarks': this.$store.state.remark, //订单备注

          'system': this.$store.state.system, //安裝位置備註
          'collecting': this.$store.state.userdata.collecting, //否收牙模 1是 0否
          'dentist_name_id': this.dentist_name_id, //牙医姓名ID
          'gender': this.$store.state.userdata.gender, //性別 1 男 2女
          'age': this.$store.state.userdata.age, //年齡
          'operator': this.DentistName, //操作人
          'install_canvas': this.$store.state.install_canvas, //安裝位置繪圖（base64格式）
          'delivery_method': this.$store.state.delivery_method, //送貨方式id
          'fast_odd_numbers': this.$store.state.fast_odd_numbers, //快遞單號
          'backstage_completion_time': this.$store.state.backstage_completion_time, //預計完成日期
          'shipping_date': this.$store.state.shipping_date, //出貨日期.
          // 新增字段
          'our_remarks':this.$store.state.our_remarks,  // 我方备注
          'salesperson_id':this.$store.state.salesperson_id,  // 销售员ID(用戶)
          'custom_amount':this.$store.state.custom_amount,  // 金额
          'charge_amount':this.$store.state.charge_amount,  // 加工费or运输费
          'your_remarks':this.$store.state.your_remarks,  // 供方备注
          'reference_number':this.$store.state.reference_number,  //  Lab编号 lab reference no
          'service_grade':this.$store.state.service_grade,  //  服务等级
          'dental_model_quantity':this.$store.state.dental_model_quantity,  //no of 牙模
          'technician_name':this.$store.state.technician_name,  // Technician name
          'courier_odd_numbers':this.$store.state.courier_odd_numbers,  // lab 快遞單號
          'customer_id':this.$store.state.userdata.customer_id,  // 客戶公司ID
        }
      },
      // 选择凭证文件后提交定金,带凭证
      Submission_deposit() {
        let formData = new window.FormData()
        formData.append('file', document.getElementById('file_voucher').files[0])
        formData.append('id', sessionStorage.getItem('order_id'))
        let fileName = this.value + '-' + sessionStorage.getItem('quotation_code').replace(/\//, "-") + '-0' + (this.$store.state.payment_record.length + 1)
        formData.append('fileName', fileName)
        console.log(formData.file, this.$store.state.payment_status)
        uploadFile(formData).then((data) => {
          if (data.status) {
            this.$store.commit('set_enclosure', data.file_path) //订单附件
            let parameter = {
              payment_note: this.value,
              payment_money: this.deposit_amount,
              payment_document: data.file_path[data.file_path.length - 1],
            }
            payment_money(parameter).then(data => {
              console.log(data)
              if (data.status) {
                this.onreturn(true)
                // 提交成功后更新订单金额
                let deposit_amount = 0
                data.data.map(itme => {
                  deposit_amount += Number(itme.payment_money)
                })
                this.$store.commit('set_deposit_amount', deposit_amount) //定金金额
                this.$store.commit('set_payment_record', data.data) //订单定金支付列表
                if (this.$store.state.client) {
                  MessageBox({
                    title: '提示',
                    message: '提交成功',
                  }).then(() => {
                  });
                }
                else {
                  this.$alert('提交成功', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                }
              }
            })
          }
          else {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '上传失败',
              }).then(() => {
              });
            }
            else {
              this.$alert('上传失败', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        })
      },
      // 直接提交定金,不带凭证
      onfile_Submission_deposit() {
        let parameter = {
          payment_note: this.value,
          payment_money: this.deposit_amount,
        }
        payment_money(parameter).then(data => {
          console.log(data)
          if (data.status) {
            this.onreturn(true)
            // 提交成功后更新订单金额
            let deposit_amount = 0
            data.data.map(itme => {
              deposit_amount += Number(itme.payment_money)
            })
            this.$store.commit('set_deposit_amount', deposit_amount) //定金金额
            this.$store.commit('set_payment_record', data.data) //订单定金支付列表
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '提交成功',
              }).then(() => {
              });
            }
            else {
              this.$alert('提交成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        })
      },
    },
    computed: {
      PostDiscountPrice: function () {
        let num_str = ''
        if (this.$store.state.orderdiscount_id === 'Approval') {
          // 将个位数保持在0
          num_str = Math.floor(this.alltotal - this.orderdiscountresult).toString()
          return Number(num_str.slice(0, num_str.length - 1) + 0)
        }
        else {
          num_str = Math.floor(this.alltotal - Math.min(this.orderdiscountresult, this.discount)).toString()
          return Number(num_str.slice(0, num_str.length - 1) + 0)
        }
      },
      // 定金
      Deposit: function () {
        let num_str = (this.PostDiscountPrice * 0.7).toFixed(0)
        let g = num_str.slice(num_str.length - 1, num_str.length)
        if (Number(g) >= 1) {
          return (Number(num_str.slice(0, num_str.length - 1)) + 1) + '0'
        }
        else {
          return Number(num_str)
        }
      },
      Subtotal: function () {
        if (this.$store.state.orderdiscount_id === 'Approval') {
          return (this.total - this.orderdiscountresult).toFixed(2)
        }
        else {
          return (this.total - Math.min(this.orderdiscountresult, this.discount)).toFixed(2)
        }
      },
      //审批金额
      audit_money: function () {
        return (this.total * (this.audit_preferences / 100)).toFixed(2)
      },
      //审批后的总金额
      audit_total: function () {
        return (this.total - (this.total * (this.audit_preferences / 100))).toFixed(2)
      },
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/less/base";

  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .cursor {
      cursor: pointer;
      .title_name{
        display: inline-block;
        width: 80px;
        margin-top: 10px;
      }
      .bold{
        font-weight: bold;
      }
    }
    .toptitle {
      position: fixed;
      z-index: 1;
      width: 90%;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      display: flex;
      justify-content: space-between;
      padding: 0 5%;
      img {
        height: 46px;
        cursor: pointer;
      }
      > div {
        display: flex;
        .personalicon {
          margin-left: 10px;
          img {
            height: 32px;
            /*margin-left: 10px;*/
          }
        }
      }
      .return {
        font-size: 40px;
        cursor: pointer;
      }
    }
    .max_audit_box {
      border-radius: 5px;
    }
    .flex_order {
      display: flex;
      flex-direction: column;
    }
    .approval_discount {
      border-radius: 5px;
      width: 80vw;
      height: 50vh;
      padding: 5% 0;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      @media (min-width: @screen-xs-max) {
        width: 50vw;
      }
      > div {
        padding: 0 5%;
        margin-bottom: 10px;
        &.input1 {
          margin-bottom: 20px;
          width: 30%;
        }
        &.input {
          margin-bottom: 10px;
          width: 80%;
          > textarea {
            width: 100%;
            border: 1px solid #DCDFE6;
            text-indent: 10px;
            padding: 5px;
            resize: none;
          }
        }
        &.audit_meassage {
          margin-top: 20px;
          div {
            margin-bottom: 10px;
          }
        }
        &.operation {
          margin-top: 30px;
          display: flex;
          justify-content: space-around;
          > button {
            cursor: pointer;
          }
        }
      }
    }
    .PersonalCenter {
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1 {
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div {
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .paymentmethod {
      backgrond-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 10%;
      text-align: center;
      .price {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .paymentmethodbut {
        .mint-button {
          margin-right: 20px;
          cursor: pointer;
        }
      }
      @media (min-width: @screen-xs-max) {
        > div {
          width: 46%;
          margin: 0 auto;
          .mint-cell {
            cursor: pointer;
          }
        }
      }
      h1 {
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div {
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .signature_box {
      backgrond: #fff;
      height: 25vh;
      width: 80vw;
      padding-top: 10%;
      text-align: center;
      @media (min-width: @screen-xs-max) {
        width: 25vw;
      }
      ul {
        padding-bottom: 20px;
        li {
          margin-top: 20px;
        }
      }
      .paymentmethodbut {
        display: flex;
        justify-items: center;
        justify-content: center;
        .mint-button {
          /*margin-right: 20px;*/
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .add_subsidiaries_box{
      .signature_box {
        padding: 50px;
        height: auto;
        div{
          div{
            margin-bottom: 20px;
          }
        }
      }
    }
    .messagebox {
      padding: 0.4rem 0.2rem;
      background: #fffbf1;
      border: 1px solid #dedbdb;
    }
    .shoppingcartbox {
      @media (min-width: @screen-xs-max) {
        background-color: #fff;
        display: flex;
        padding: 0 2%;
        /*margin-top: 52px;*/
        justify-content: space-between;
        > div {
          width: 46%;
        }
      }
    }
    .select_product_box{
      >div{
        padding: 10px 0;
        .title_name{
          margin-right: 10px;
        }
      }
    }
    .list_obx{
      margin-top: 20px;
      >div{
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        >div{
          width: 20%;
          text-align: center;
          .el-icon-minus{
            cursor: pointer;
            font-size: 26px;
            font-weight: bold;
          }
        }
      }
    }
    .lsitbox {
      > ul {
        background: #fff;
        li {
          padding: 0.2rem;
          /*display: flex;*/
          justify-content: space-between;
          border-bottom: 1px solid #e8e8e8;
          height: 34px;
          overflow: hidden;
          .box2 {
            display: flex;
            > div {
              /*width: 48%;*/
              img {
                width: 100%;
                cursor: pointer;
              }
            }
            .show_img {
              cursor: pointer;
              overflow: hidden;
              img {
                width: 100%;
                /*max-height: 90vh;*/
              }
            }
          }

          p {
            display: inline-block;
            justify-content: space-between;
            width: 46%;
          }
          .titlenamebox {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .asterisk {
              font-size: 14px;
              color: red;
            }
            .editbox {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .edit {
                font-size: 14px;
                height: 24px;
                padding: 0 8px;
                margin-left: 5px;
                cursor: pointer;
              }
            }
          }
          &.showproductattribute {
            height: auto;
          }
          .childattribute {
            padding-left: 5%;
            display: flex;
            align-items: start;
            justify-content: space-between;
            .title_name{
              margin-bottom: 20px;
            }
            >div{
              width: 48%;
            }
            .accessories_picture_box{
              >img{
                width: 100px;
              }
            }
            p {
              margin-top: 0.1rem;
              width: 100%;
              span {
                display: inline-block;
                width: 46%;
                margin-right: 1%;
              }
            }
          }
          .childpartsIn {
            width: 40%;
            padding-left: 6%;
          }
          .delete {
            width: 4%;
            font-size: 26px;
            text-align: center;
            cursor: pointer;
            span {
              margin-left: 20px;
            }
          }
          ul {
            /*padding-left: 0.2rem;*/
            height: 0;
            overflow: hidden;
            /*transition: all 1s;*/
            /*padding-left: 4%;*/
            &.active {
              margin-top: 0.2rem;
              height: auto;
            }
            li {
              padding: 0.2rem 0;
              border-bottom: none;
              height: 20px;
              overflow: hidden;
              &.showattribute {
                height: auto;
              }
              .lastchildattribute {
                padding-left: 11%;
              }
              .delete {
                width: 4%;
                font-size: 26px;
                color: #fff;
              }
              .threeparts {
                margin-left: 20px;
                .childpartsIn {
                  width: 37%;
                  @media (min-width: @screen-xs-max) {
                    width: 38%;
                  }
                }
              }
            }
          }
        }
      }
    }
    .img_model {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      /*background: rgba(0, 0, 0, 0.5);*/
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 90%;
        width: 60%;
      }
    }
    .from_box {
      width: 100%;
      border: 1px solid #dcd7d7;
      padding: 20px;
      display: flex;
      flex-direction: column;
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0;
        .input_box {
          width: 50%;
        }
        textarea {
          width: 100%;
          height: 60px;
          border: 1px solid #d4c8c8;
          padding: 10px;
        }
      }
    }
    .addbut {
      width: 45px;
      line-height: 30px;
      border-radius: 50%;
      background: #f6b83f;
      color: #fff;
      padding: 0.3rem 0.2rem;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin: 20px auto;
      cursor: pointer;
    }
    .costbox {
      padding: 0.2rem;
      background-color: #fff;
      ul {
        li {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          margin-top: 0.2rem;
          &.changeinstallationfeebox {
            flex-direction: column;
            cursor: pointer;
            div {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              span {
                display: flex;
                justify-content: space-between;
                align-items: center;
                span {
                  font-size: 26px;
                  margin-left: 0.1rem;
                  &.arrow {
                    font-size: 20px;
                    transition: all 0.5s;
                  }
                  &.open {
                    transform: rotate(90deg);
                  }
                  .red {
                    color: #e4e7ed;
                  }
                }
              }
            }
          }
        }
        .gray {
          color: #a6a6a6;
        }
      }
    }
    .totalbox {
      margin: 2px 0;
      padding: 0.2rem;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      &.preferencebox {
        display: flex;
        justify-content: flex-end;
      }
      .orderdiscount {
        display: flex;
        /*justify-items: center;*/
        width: 40%;
        align-items: center;
        > span {
          width: 30%;
        }
        > div {
          width: 110px;
        }
      }
      .num {
        color: @maincolor;
        /*font-size: 18px;*/
      }
    }
    .all_payment_money {
      cursor: pointer;
      span {
        display: flex;
        align-items: center;
      }
      .arrow {
        margin-left: 0.1rem;
        font-size: 20px;
        transition: all 0.5s;
      }
      .open {
        transform: rotate(90deg);
      }
    }
    .payment_money {
      display: flex;
      justify-content: space-between;
      span {
        display: block;
        width: 30%;
        text-align: center;
      }
    }
    .meassagebox {
      justify-content: center;
      span {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
    .remarksbox {
      textarea {
        height: 50px;
        width: 100%;
        resize: none;
        font-size: 16px;
        /*padding-left: 0.2rem;*/
        text-indent: 0.2rem;
      }
    }
    .modebox {
      padding: 0.2rem;
      background-color: #f2f2f2;
      font-size: 16px;
      border-bottom: 1px solid #979797;
      border-top: 1px solid #979797;
      ul {
        display: flex;
        justify-content: space-between;
        li {
          .garden {
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #979797;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            color: #fff;
          }
        }
        .active {
          .garden {
            background: @maincolor2;
          }
        }
      }
    }
    .collecting_box {
      padding: 0.2rem;
      background-color: #f2f2f2;
      font-size: 16px;
      border-bottom: 1px solid #979797;
      border-top: 1px solid #979797;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .form_box {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      padding: 0.4rem 0.2rem;
      > label {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
      }
      &.changeinstallationfeebox {
        flex-direction: column;
        div {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.5s;
        }
      }
      &.upfile {
        label {
          cursor: pointer;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      &.file_voucher {
        display: none;
      }
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-icon-plus{
          margin-right: 20px;
          font-size: 20px;
        }
        span {
          font-size: 26px;
          margin-left: 0.1rem;
          transition: all 0.5s;
          &.show {
            transform: rotate(90deg);
          }
        }
      }
      .meassagetitle {
        width: 150px;
      }
      .address_box{
        width: 80%;
        .el-select{
          width: 100%;
        }
      }
      .date_box {
        width: 76px;
        /deep/ input {
          border: none;
          padding: 0;
        }
        /deep/ i {
          display: none;
        }
      }
      .filename {
        display: flex;
        justify-content: flex-end;
        word-break: break-all;
        .delbut {
          font-size: 14px;
          color: #e8e8e8;
        }
      }
    }
    .usermeassagebox {
      ul {
        padding-top: 0;
        background-color: #fff;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e8e8e8;
          padding: 0.4rem 0.2rem;
          > label {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
          }
          &.changeinstallationfeebox {
            flex-direction: column;
            div {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              transition: all 0.5s;
            }
          }
          &.upfile {
            label {
              cursor: pointer;
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
          &.file_voucher {
            display: none;
          }
          span {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 26px;
              margin-left: 0.1rem;
              transition: all 0.5s;
              &.show {
                transform: rotate(90deg);
              }
            }
          }
        }
      }
    }
    .usermeassagebox2 {
      background: #fff;
      padding-top: 0;
      ul {
        li {
          cursor: pointer;
          .meassagetitle {
            width: 150px;
          }
          .date_box {
            width: 76px;
            /deep/ input {
              border: none;
              padding: 0;
            }
            /deep/ i {
              display: none;
            }
          }
          .filename {
            display: flex;
            justify-content: flex-end;
            word-break: break-all;
            .delbut {
              font-size: 14px;
              color: #e8e8e8;
            }
          }
        }
      }
    }
    .footerbox {
      padding: 0.3rem 0.2rem;
      background-color: #f7f7f7;
      font-size: 14px;
      color: #a6a6a6;
      @media (min-width: @screen-xs-max) {
        display: none;
      }
    }
    .butmaxbox {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      @media (min-width: @screen-xs-max) {
        padding: 50px 0;
        background-color: #fff;
      }
      .el-dropdown {
        width: 50%;
        > span {
          width: 100%;
          display: block;
          .butbox {
            width: 100%;
          }
        }
      }
      .butbox {
        width: 50%;
        background: @maincolor2;
        color: #fff;
        padding: 0.3rem 0.2rem;
        font-size: 18px;
        text-align: center;
        &.order_id {
          background: #979797;
        }
      }
      .butbox2{
        background: #51c8ff;
        a{
          color: #fff;
        }
      }
      .SettlementButton {
        background: #57c5f7;
      }
      .w100 {
        width: 98%;
      }
      .pdf {
        background-color: @maincolor;
      }
    }
    .pdfimgmode {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      z-index: 999999;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all;
      background-color: rgba(0, 0, 0, 0.5);
      iframe {
        width: 70%;
        height: 90%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/delivery_details.vue